
<div class="col-xl-12 no-padding">
    <div class="row small-section-content">


        <div class="col-md-3 col-sm-3 col-xs-12 no-padding">
            <div tooltip="Purchased" class="hbgPortalGreen" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{accountCredits.purchased}}
                    </p>
                    <small>
                        PURCHASED
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 no-padding">
            <div tooltip="Consumed" class="hbgPortalWhite" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{accountCredits.consumed}}
                    </p>
                    <small>
                        CONSUMED
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 no-padding">
            <div tooltip="Reserved" class="hbgPortalGrey" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{accountCredits.reserved_for_Delivery}}
                    </p>
                    <small>
                        RESERVED
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>
        <div class="col-md-3 col-sm-3 col-xs-12 no-padding">
            <div tooltip="Balance" class="hpanel hbgPortalDisabled" style="">
                <!--<div class="panel-body hbgPortalGreen" style="padding: 20px;">-->
                <div class="text-center">
                    <p class="text-small caseFont" style="margin: 0px;">
                        {{accountCredits.balance}}
                    </p>
                    <small>
                        BALANCE
                    </small>
                </div>
                <!--</div>-->
            </div>
        </div>



    </div>
</div>
